import React, { FC, useState } from "react";
import Select from "shared/components/Form/Select";
import TextField from "shared/components/Form/TextField";
import Modal from "shared/components/Modal";
import { COLOR_BLACK } from "shared/theme/colors";
import { languages, LocaleCode } from "shared/types/languages";
import { useArticleGroupPage } from "../../context";

type Props = {
  open: boolean;
  onClose: () => void;
};

const CreatingArticleModal: FC<Props> = ({ open, onClose }) => {
  const [name, setName] = useState<string>("");
  const [language, setLanguage] = useState<LocaleCode>(LocaleCode.en);

  const { handleCreatingArticleDetails, isLoadingCreateArticle } =
    useArticleGroupPage();

  const languageOptions = languages.map((language) => ({
    value: language.id,
    label: language.name,
  }));

  const onCloseModal = () => {
    onClose();
    setName("");
    setLanguage(LocaleCode.en);
  };

  const onSubmit = async () => {
    await handleCreatingArticleDetails({
      language,
      name,
    });
  };

  return (
    <Modal
      open={open}
      onClose={onCloseModal}
      title="Create document"
      primaryButtonTitle="Add"
      primaryColor="primary"
      secondaryButtonTitle="Cancel"
      onSecondaryClick={onCloseModal}
      onPrimaryClick={onSubmit}
      isSubmitting={isLoadingCreateArticle}
      isDisabled={!language || !name}
    >
      <TextField
        label="Document name*"
        placeholder="Enter document name"
        labelColor={COLOR_BLACK}
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <Select
        label="Language*"
        labelColor={COLOR_BLACK}
        value={language}
        onChange={(e) => setLanguage(e.target.value as LocaleCode)}
        options={languageOptions}
        isHiddenPlaceholder
      />
    </Modal>
  );
};

export default CreatingArticleModal;
